<template>
    <div class="footer">
        <footer>
            <p>ALL  RIGHTS  RESERVED.广州影美晴信息科技有限责任公司  粤B2-20201114 | 粤网文（2018）8475-3059号 | <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备14050742号-3</a> | <a style="display:inline-block;text-decoration: none;"><img src="../assets/gongan.png" style="height:16px;"/>粤公网安备 44010602008967号</a></p>
        </footer>
    </div>
</template>

<script>

    export default {
        name: 'footer',
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>


<style scoped>
    footer {margin: 0;  padding: 0;  list-style: none;  }
    footer{height: 180px;background: #fff;padding: 70px 0 0;}
    footer p, footer a{font-size: 12px;color: #999;text-align: center;}
</style>
